import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Logo from "../../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf";
import moment from "moment";
import {
  sendInvoice,
  addTotalInvoiceAmount,
} from "../../redux/features/sales.features";

const InvoiceViewer = (props) => {
  const componentRef = useRef();
  const letterHeadPrintRef = useRef();
  const [invoiceItemDisc, setInvoiceItemDiscount] = useState(0);

  let userState = useSelector((state) => {
    return state.userReducer;
  });

  let { user } = userState;

  var doc = new jsPDF("p", "pt", "a3", true);
  const print = useReactToPrint({
    pageStyle: `  
    @media print{
      @page {
          margin-top: 10px;
          margin-bottom: 10px;
          size: A3;
           }
      body{
          
          -webkit-print-color-adjust: exact;
      }
      section{
      
      background-color: white;
  }
  h1{
      font-size: 10px;
      
  }
  p{
      font-size: 9px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => componentRef.current,
  });
  const letterHeadPrint = useReactToPrint({
    pageStyle: `  
    @media print{
      @page {
          margin-top: 250px;
          margin-bottom: 20px;
          size: A3;
           }
      body{
          
          -webkit-print-color-adjust: exact;
      }
      section{
      
      background-color: white;
  }
  h1{
      font-size: 12px;
      
  }
  p{
      font-size: 9px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => letterHeadPrintRef.current,
  });

  let dispatch = useDispatch();

  const salesState = useSelector((state) => {
    return state.salesReducer;
  });

  const { invoice, recentAddedInvoice, sales } = salesState;

  const a = {
    invoiceCreatedDate: "27/06/2022",
    invoiceType: "Sales",
    invoiceCategory: "Visit",
    invoiceSubCategory: "USA Trip 1",
    invoiceCurrency: "USD",
    invoiceShipmentStatus: "InProgress",
    invoicePaymentType: "Cash",
    invoiceStatus: "InProgress",
    invoiceCustomer: [],
    invoiceBanks: [
      {
        id: "BANK-2",
        bankName: "COMMERCIAL BANK",
        branch: "Beruwala",
        accountNo: "432121212",
        status: "Active",
      },
    ],
    invoiceSubTotal: 244,
    invoiceDiscountAmount: 0,
    invoiceSubTotalAfterDiscount: 244,
    invoiceGrandTotal: 244,
    invoiceExtraCharges: 0,
    invoiceTotalAmountReceived: "250",
    invoiceBalanceToReceived: 0,
    invoiceBalanceToCustomer: 6,
    invoiceDate: "27/06/2022",
  };

  const sendMail = () => {
    doc.html(componentRef.current, {
      html2canvas: {
        // scale: 595.26 / srcwidth, //595.26 is the width of A4 page
        // scrollY: 0
      },
      callback: function (doc) {
        // doc.internal.pageSize.width = "2000px"
        // doc.internal.pageSize.height = ""
        console.log("pdf", doc);
        let name = new Date();
        // doc.save(name.toISOString()+".pdf");
        // window.open(doc.output('dataurlnewwindow'))
        dispatch(sendInvoice(doc, invoice));
      },
      x: 10,
      y: 10,
    });
  };

  const downloadPdf = () => {
    //   doc.addHTML(componentRef.current, function () {
    //     doc.save('Test.pdf');
    // });
    // let srcwidth = document.getElementById('toPDF').scrollWidth;
    doc.html(componentRef.current, {
      html2canvas: {
        // scale: 595.26 / srcwidth, //595.26 is the width of A4 page
        // scrollY: 0
      },
      callback: function (doc) {
        // doc.internal.pageSize.width = "2000px"
        // doc.internal.pageSize.height = ""
        console.log("pdf", doc);
        let name = new Date();
        doc.save(name.toISOString() + ".pdf");
        // window.open(doc.output('dataurlnewwindow'))
      },
      x: 10,
      y: 10,
    });
  };

  return (
    <div className="bg-black p-5">
      <div
        id="toPDF"
        style={{ maxWidth: 850, minHeight: 1150, overflowY: "scroll" }}
        className=""
      >
        <main
          ref={componentRef}
          className="bg-white text-black p-5 scroll-m-1 mx-5"
        >
          <section className="flex flex-row w-full p-5">
            <div className="flex flex-col  justify-start ">
              <div className="flex flex-col justify-start items-start">
                <img style={{ width: 150 }} className="" src={Logo} alt="" />
                <p className="w-full my-3 p-3 bg-blue-600 text-cyan-50">
                  Billing From{" "}
                </p>
                <p className="pt-2 text-3xl font-bold">SHIMLA GEM </p>
                <ul className="font-bold">
                  <li>
                    <span className=" font-light">
                      30, Yusuf Avenue, China Fort,
                    </span>
                  </li>
                  <li>
                    <span className=" font-light">
                      Beruwala -12070, Sri Lanka.
                    </span>
                  </li>
                  <li>
                    {" "}
                    <span className=" font-light">+94 775871563</span>
                  </li>
                  <li>
                    {" "}
                    <span className=" font-light">shimlagems@gmail.com</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ml-auto text-right">
              <p
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
                className="justify-end flex items-center font-bold text-2xl uppercase"
              >
                {invoice.invoiceType === "sales"
                  ? "Invoice"
                  : invoice.invoiceType}{" "}
                -
                <i
                  style={{
                    backgroundColor: "orange",
                    marginBottom: 5,
                    padding: 10,
                  }}
                  className="flex item-center   text-black text-xs rounded"
                >
                  {invoice.invoiceStatus || "Invoice need to save"}
                </i>
              </p>
              <div className="flex w-full justify-end items-center">
                <div className="mx-3">
                  {invoice.invoiceNumber || (
                    <i
                      style={{
                        backgroundColor: "orange",
                        marginTop: 5,
                        padding: 10,
                      }}
                      className="flex items-center text-xs text-black rounded"
                    >
                      Invoice need to save
                    </i>
                  )}
                </div>
                <div className="">
                  {moment(invoice.invoiceCreatedDate).format("DD-MM-YYYY")}
                </div>
              </div>

              <div className="mt-5 flex flex-col">
                <p className="my-3 p-3 bg-blue-600 text-cyan-50">
                  {" "}
                  Billing To{" "}
                </p>
                {invoice.invoiceType === "Sales" ? (
                  <ul>
                    <li>
                      <span>
                        {invoice.invoiceCustomer &&
                        invoice.invoiceCustomer.length !== 0 &&
                        user.role === "admin"
                          ? invoice.invoiceCustomer[0].businessName
                          : "*******"}
                      </span>
                    </li>
                    <li>
                      {invoice.invoiceCustomer &&
                      invoice.invoiceCustomer.length !== 0 &&
                      user.role === "admin"
                        ? invoice.invoiceCustomer[0].businessAddress
                        : "***********"}
                    </li>
                    <li>
                      {invoice.invoiceCustomer &&
                      invoice.invoiceCustomer.length !== 0 &&
                      user.role === "admin"
                        ? invoice.invoiceCustomer[0].businessCity
                        : "***********"}{" "}
                      {invoice.invoiceCustomer &&
                      invoice.invoiceCustomer.length !== 0 &&
                      user.role === "admin"
                        ? invoice.invoiceCustomer[0].businessCountry
                        : "***********"}{" "}
                    </li>
                    <li>
                      {invoice.invoiceCustomer &&
                      invoice.invoiceCustomer.length !== 0 &&
                      user.role === "admin"
                        ? invoice.invoiceCustomer[0].businessContact
                        : "***********"}
                    </li>
                    <li>
                      {invoice.invoiceCustomer &&
                      invoice.invoiceCustomer.length !== 0 &&
                      user.role === "admin"
                        ? invoice.invoiceCustomer[0].businessEmail
                        : "***********"}
                    </li>
                    <li>
                      {invoice.invoiceCustomer &&
                      invoice.invoiceCustomer.length !== 0 &&
                      invoice.invoiceCustomer[0].businessVatNumber !==
                        undefined &&
                      invoice.invoiceCustomer[0].businessVatNumber !== "" ? (
                        user.role === "admin" ? (
                          "VAT No. : " +
                          invoice.invoiceCustomer[0].businessVatNumber
                        ) : (
                          "***********"
                        )
                      ) : (
                        <i></i>
                      )}
                    </li>
                  </ul>
                ) : (
                  <ul>
                    <li>
                      <span>
                        {invoice.invoiceBroker &&
                          invoice.invoiceBroker.length !== 0 &&
                          invoice.invoiceBroker[0].firstName}
                      </span>
                    </li>
                    <li>
                      {invoice.invoiceBroker &&
                        invoice.invoiceBroker.length !== 0 &&
                        invoice.invoiceBroker[0].homeAddress}
                    </li>
                    <li>
                      {invoice.invoiceBroker &&
                        invoice.invoiceBroker.length !== 0 &&
                        invoice.invoiceBroker[0].city}{" "}
                      {invoice.invoiceBroker &&
                        invoice.invoiceBroker.length !== 0 &&
                        invoice.invoiceBroker[0].country}{" "}
                    </li>
                    <li>
                      {invoice.invoiceBroker &&
                        invoice.invoiceBroker.length !== 0 &&
                        invoice.invoiceBroker[0].mobile}
                    </li>
                    <li>
                      {invoice.invoiceCustomer &&
                        invoice.invoiceCustomer.length !== 0 &&
                        invoice.invoiceCustomer[0].email}
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </section>

          <hr className="my-10 "></hr>
          <section ref={letterHeadPrintRef}>
            <section
              style={{
                maxWidth: 950,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="flex  items-center w-full p-5"
            >
              <div className="md:px-2 py-2 w-full">
                <div className="shadow  rounded border-b border-gray-200">
                  <table className="min-w-full bg-white">
                    <thead className="bg-gray-800 text-white">
                      <tr>
                        <th
                          style={{ width: 30 }}
                          className=" text-left py-3  uppercase font-semibold text-sm"
                        >
                          #No
                        </th>
                        <th
                          style={{ width: 30 }}
                          className="text-center py-3  uppercase font-semibold text-sm"
                        >
                          ID
                        </th>
                        <th className=" text-center py-3 px-2 uppercase font-semibold text-sm">
                          DESCRIPTION
                        </th>
                        <th
                          style={{ width: 30 }}
                          className=" text-center py-3  uppercase font-semibold text-sm"
                        >
                          Pcs
                        </th>
                        <th className="text-center py-3 px-1 uppercase font-semibold text-sm">
                          H/N
                        </th>
                        <th
                          style={{ width: 30 }}
                          className="text-center py-3 px-1 uppercase font-semibold text-sm"
                        >
                          WEIGHT
                        </th>
                        <th className="text-right py-3 px-2 uppercase font-semibold text-sm">
                          PRICE ({invoice.invoiceCurrency})
                        </th>
                        {invoice.invoiceItemList.filter(
                          (x) =>
                            x.itemDiscountAmount && x.itemDiscountAmount !== 0
                        ).length !== 0 && (
                          <th className="text-center py-3 px-2 uppercase font-semibold text-sm">
                            discount
                          </th>
                        )}
                        <th className="text-center py-3 px-2 uppercase font-semibold text-sm">
                          SUB TOTAL ({invoice.invoiceCurrency})
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-700">
                      {invoice.invoiceItemList &&
                        invoice.invoiceItemList.map((x, i) => {
                          return (
                            <tr key={i} className="bg-gray-100">
                              <td
                                style={{ width: 20 }}
                                className=" text-left py-3 "
                              >
                                {i + 1}
                              </td>
                              <td
                                style={{ width: 20 }}
                                className=" text-center py-3 "
                              >
                                {x.productId}
                              </td>
                              <td className=" text-center py-3 px-1">
                                {x.title}
                              </td>
                              <td
                                style={{ width: 20 }}
                                className=" text-center py-3 "
                              >
                                {x.buyPiece || 1}
                              </td>
                              <td className="text-center py-3 px-1">
                                {x.treatment_type === "Natural"
                                  ? "N"
                                  : x.treatment_type === "Heated"
                                  ? "H"
                                  : x.treatment_type}
                              </td>
                              <td
                                style={{ width: 30 }}
                                className="text-center py-3 px-1"
                              >
                                {x.weight}ct
                              </td>
                              <td className="text-right py-3 px-1">
                                {" "}
                                {invoice.invoiceCategory === "Local"
                                  ? Number(x.sellPriceLocal).toLocaleString()
                                  : Number(
                                      x?.priceVariant === "true"
                                        ? x.sellPriceForeigners2
                                        : x.sellPriceForeigners
                                    ).toLocaleString()}{" "}
                                {/* {invoice.invoiceCurrency} */}
                              </td>
                              {x.itemDiscountAmount &&
                                x.itemDiscountAmount !== 0 && (
                                  <td className="text-right py-3 px-1">
                                    {x.itemDiscountAmount || "0.00"}
                                  </td>
                                )}
                              <td className="text-right py-3 px-1">
                                {invoice.invoiceCurrency === "LKR"
                                  ? Number(
                                      x.sellPriceLocal -
                                        (x.itemDiscountAmount || 0)
                                    ).toLocaleString()
                                  : Number(
                                    (x?.priceVariant === "true"
                                    ? x.sellPriceForeigners2
                                    : x.sellPriceForeigners) -
                                    (x.itemDiscountAmount || 0)
                                    ).toLocaleString()}{" "}
                                {/* {invoice.invoiceCurrency} */}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>

            <section style={{ maxWidth: 850 }} className="mt-5 flex w-full p-5">
              <div style={{ maxWidth: 400 }} className="mt-3">
                {invoice.invoiceBanks &&
                  invoice.invoiceBanks.length !== 0 &&
                  invoice.invoiceBanks.map((x, i) => {
                    return (
                      <div key={i} className="flex flex-col text-sm my-4">
                        <div className="font-extrabold text-lg py-1">
                          {x.bankName}
                        </div>
                        {x?.branch && x?.branch !== "" && (
                          <div className="font-bold">
                            Bank Branch :{" "}
                            <span className="font-normal">{x.branch}</span>
                          </div>
                        )}
                        {x?.accountName && x?.accountName !== "" && (
                          <div className="font-bold">
                            Bank Account Name :{" "}
                            <span className="font-normal">
                              {x?.accountName}
                            </span>
                          </div>
                        )}
                        {x?.accountNo && x?.accountNo !== "" && (
                          <div className="font-bold">
                            Bank Account No :{" "}
                            <span className="font-normal">{x.accountNo}</span>
                          </div>
                        )}
                        {x?.swiftCode && x?.swiftCode !== "" && (
                          <div className="font-bold">
                            Bank Swift Code :{" "}
                            <span className="font-normal">{x?.swiftCode}</span>
                          </div>
                        )}
                        {x?.bankCode && x?.bankCode !== "" && (
                          <div className="font-bold">
                            Bank Code :{" "}
                            <span className="font-normal">{x?.bankCode}</span>
                          </div>
                        )}
                        {x?.bankAddress && x?.bankAddress !== "" && (
                          <div className="font-bold">
                            Bank Address :{" "}
                            <span className="font-normal">
                              {x?.bankAddress}
                            </span>
                          </div>
                        )}
                        {x?.routingNo && x?.routingNo !== "" && (
                          <div className="font-bold">
                            Bank Routing No :{" "}
                            <span className="font-normal">{x?.routingNo}</span>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
              <div className="ml-auto">
                <div className="flex justify-between text-2xl">
                  <div className="p-2 font-extrabold">Sub Total</div>
                  <div className="p-2 font-bold text-right">
                    {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                    {Number(invoice.invoiceSubTotal).toLocaleString()}{" "}
                  </div>
                </div>
                {invoice.invoiceDiscountAmount &&
                Number(invoice.invoiceDiscountAmount) !== 0 ? (
                  <>
                    <hr></hr>
                    <div className="flex justify-between">
                      <div className="p-2 font-bold">Discount</div>
                      <div className="p-2 font-bold text-right">
                        {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                        {Number(
                          invoice.invoiceDiscountAmount
                        ).toLocaleString()}{" "}
                      </div>
                    </div>
                  </>
                ) : null}
                {invoice.invoiceExtraCharges &&
                Number(invoice.invoiceExtraCharges) !== 0 ? (
                  <>
                    <hr></hr>
                    <div className="flex justify-between">
                      <div className="p-2 font-bold">Extra Charges</div>
                      <div className="p-2 font-bold text-right">
                        {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                        {Number(invoice.invoiceExtraCharges).toLocaleString()}
                      </div>
                    </div>
                  </>
                ) : null}
                <hr></hr>
                <div className="flex justify-between">
                  <div className="p-2 font-extrabold">Grand Total</div>
                  <div className="p-2 font-bold text-right">
                    {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                    {Number(invoice.invoiceGrandTotal).toLocaleString()}{" "}
                  </div>
                </div>
                {invoice.invoiceTotalAmountReceived &&
                Number(invoice.invoiceTotalAmountReceived) !== 0 ? (
                  <>
                    <hr style={{ height: 5 }}></hr>
                    <div className="flex justify-between">
                      <div className="p-2 font-bold">Total Amount Received</div>
                      <div className="p-2 font-bold text-right">
                        {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                        {Number(
                          invoice.invoiceTotalAmountReceived
                        ).toLocaleString()}{" "}
                      </div>
                    </div>
                  </>
                ) : null}

                {invoice.invoiceBalanceToReceived &&
                Number(invoice.invoiceBalanceToReceived) !== 0 ? (
                  <>
                    <hr></hr>
                    <div className="flex justify-between">
                      <div className="p-2 font-bold">Balance To Received</div>
                      <div className="p-2 font-bold text-right">
                        {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                        {Number(
                          invoice.invoiceBalanceToReceived
                        ).toLocaleString()}{" "}
                      </div>
                    </div>
                  </>
                ) : null}

                {invoice.invoiceBalanceToCustomer &&
                Number(invoice.invoiceBalanceToCustomer) !== 0 ? (
                  <>
                    <hr></hr>
                    <div className="flex justify-between">
                      <div className="p-2 font-bold">Balance To Customer</div>
                      <div className="p-2 font-bold text-right">
                        {invoice.invoiceCurrency === "USD" ? "$" : "Rs"}
                        {Number(
                          invoice.invoiceBalanceToCustomer
                        ).toLocaleString()}{" "}
                      </div>
                    </div>
                  </>
                ) : null}

                <hr></hr>
                <div className="flex justify-between">
                  <div className="p-2 font-bold">Payment Type</div>
                  <div className="p-2 font-bold text-right">
                    {invoice.invoicePaymentType}
                  </div>
                </div>
              </div>
            </section>
          </section>
        </main>
      </div>
      <section className="py-5">
        <button
          onClick={print}
          className="p-3 mx-2 tracking-wide text-white font-bold bg-green-600 "
        >
          <i className="p-2 bx bx-printer"></i>Print
        </button>
        <button
          onClick={letterHeadPrint}
          className="p-3 mx-2 tracking-wide text-white font-bold bg-green-600 "
        >
          <i className="p-2 bx bx-printer"></i>Letter Head Print
        </button>
        <button
          onClick={() => downloadPdf()}
          className="p-3 mx-2 bg-sky-600 tracking-wide text-white font-bold"
        >
          <i className="p-2 bx bx-down-arrow-circle"></i>Download
        </button>
        <button
          onClick={() => sendMail()}
          className="p-3 mx-2 bg-pink-700 tracking-wide text-white font-bold"
        >
          {" "}
          <i className="p-2 bx bx-mail-send"></i> Send Email
        </button>
      </section>
    </div>
  );
};

export default InvoiceViewer;
